import { observeLazySources } from './modules/lazy-sources-loader.js';
import { initNewsBlocksAnalytics } from './modules/analytics.js';

/* need for old browsers without defer */
const HOMEPAGE_TEST_GROUP = `b`;

document.addEventListener(
  `DOMContentLoaded`,
  () => {
    const isHomepageBGroup = window.Site.abTests.homepage === HOMEPAGE_TEST_GROUP;

    initNewsBlocksAnalytics(document.body, { homepage_ab: isHomepageBGroup });

    /* initialization of lazy loading */
    observeLazySources();
  },
  false,
);
